export const experienceData = [
    {
        id: 1,
        company: '"Pokemons Single Page Aplication"',
        jobtitle: 'FullStack Developer',
        startYear: 'Nov 8, 2022 ',
        endYear: ' Nov 25, 2022'
    },
    {
        id: 2,
        company: '"La Dionisia" Wine E-Commerce',
        jobtitle: 'FullStack Developer',
        startYear: 'Jan 2, 2023 ',
        endYear: ' Jan 27, 2023'
    },
    {
        id: 3,
        company: 'Sirius Chat App',
        jobtitle: 'Frontend Developer',
        startYear: 'May, 2023',
        endYear: 'Present'
    },
]